<!--
 * @Author: yuka
 * @Date: 2019-07-30 19:18:37
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-08-16 16:40:31
 * @Description: 
 -->
<template>
  <div id="app" class="clearfix">
    <div class="is-pc" v-if="isPc">
      <header-nav v-if="navShow" class="header-wrapper"></header-nav>
      <div class="app-content-wrapper clearfix" ref="appContent">
        <router-view />
        <index-footer></index-footer>
      </div>
    </div>
    <div class="is-phone" v-else ref="mAppContent">
      <m-header-nav
        :mActiveIndex="mActiveIndex"
        class="m-header-wrapper"
        v-if="navShow"
      ></m-header-nav>
      <list-top-bar :title="componentsTitle" v-else></list-top-bar>
      <div class="m-app-content-wrapper clearfix" ref="appContent">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import HeaderNav from '@/components/header-nav';
import IndexFooter from '@/components/footer';
import mHeaderNav from '@/components/m-header-nav';
import listTopBar from '@/components/m-list-top';
export default {
  components: {
    HeaderNav,
    IndexFooter,
    mHeaderNav,
    listTopBar
  },
  data() {
    return {
      screenWidth: document.body.clientWidth,
      isPc: false,
      navShow: true,
      mActiveIndex: 0,
      componentsTitle: '',
      hideNav: [
        'm-jing-yu-list',
        'm-number-one-list',
        'm-lend-recoder',
        'm-check-record',
        'm-project-produce',
        'm-loan-contract',
        'm-repayment-plan',
        'm-project-detail',
        'm-detail-content',
        'orgnize-info',
        'm-orgnize-info'
      ]
    };
  },
  watch: {
    $route(e) {
      // 为了子页面跳转时，滚动定位到顶部
      this.$refs['appContent'].scrollTo(0, 0);
      if (this.hideNav.indexOf(e.name) >= 0) {
        this.navShow = false;
        this.componentsTitle = e.meta.title;
        // if (e.name !== 'm-detail-content') {
        // const that = this;
        // that.$eventBus.$emit('listBarTitle', e.meta.title)
        // this.$nextTick(console.log('nextstick'));
        // console.log(e.meta.title, this.$eventBus.$emit('listBarTitle', e.meta.title));
        // }
      } else if (e.name === 'm-project-list') {
        this.mActiveIndex = 1;
        this.navShow = true;
      } else {
        this.navShow = true;
      }
    },
    screenWidth(val, oldVal) {
      // console.log(val, oldVal);
      if (val > 768 && oldVal <= 768) {
        this.isPc = true;
        this.$router.replace('/');
      } else if (val <= 768 && oldVal > 768) {
        this.isPc = false;
        this.$router.replace('/m-index');
      }
    }
  },
  created() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
    if (this.screenWidth > 768) {
      this.isPc = true;
      this.$router.replace('/');
    } else {
      this.isPc = false;
      this.$router.replace('/m-index');
    }
  },
  mounted() {
    let head = document.head || document.getElementByTagName('head')[0] || document.documentElement;
    let script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', 'https://v1.cnzz.com/z_stat.php?id=1278997268&web_id=1278997268');
    head.appendChild(script);
    console.log(head);
    script.onload = function() {
      // 执行后续操作。
      console.log('loaded');
    };
  }
};
</script>

<style lang="less" scoped>
#app {
  width: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: relative;
  // overflow: scroll;
}
.header-wrapper {
  width: 100%;
}
.app-content-wrapper {
  width: 100%;
  position: absolute;
  top: 56px;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.is-phone {
  height: 100%;
}
.m-app-content-wrapper {
  width: 100%;
  position: absolute;
  top: 0.82rem;
  left: 0;
  bottom: 0;
  z-index: 99;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
